import React, { useState } from "react";
import { GetAllHistory } from "adminApi/CustomersApi/CustomerRefund";
import DataTable from "Common/DataTable/DataTable";
import useDebouncedValue from "Common/DataTable/useDebouncedValue";
import usePaginatedFetch from "Hooks/usePaginatedFetch";

const RefundHistoryTable = () => {
  const [search, setSearch] = useState("");
  const [limit, setLimit]   = useState(10);
  const [page, setPage]     = useState(1);
  const debouncedSearch     = useDebouncedValue(search, 500);
  const sizeOptions         = [10, 20, 50, 100];

  const { data, meta, loading, error } = usePaginatedFetch(GetAllHistory, {
    page,
    limit,
    search: debouncedSearch,
    title:  "RefundHistory",
  });

  const columns = [
    { Header: "#", accessor: "sno", disableSortBy: true },
    {
      Header: "Customer",
      accessor: "first_name",
      Cell: ({ row }) => (
        <div>
          <div className="fw-semibold">{row.original.first_name} {row.original.last_name}</div>
          <div className="text-muted small">{row.original.email || row.original.customer_phone}</div>
        </div>
      ),
    },
    {
      Header: "Refund Amount",
      accessor: "amount",
      Cell: ({ value }) => (
        <span className="fw-semibold">
          ₹ {parseFloat(value || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 })}
        </span>
      ),
    },
    
    {
      Header: "Balance After Refund",
      accessor: "balance_after",
      Cell: ({ value }) => (value != null ? `₹ ${parseFloat(value).toFixed(2)}` : "—"),
    },
    {
      Header: "Payment Status",
      accessor: "status",
      Cell: ({ value }) => (
        <span
          className={`badge fw-semibold px-3 py-2`}
          style={{
            background: value === "completed" ? "#f0fff4" : value === "rejected" ? "#fff5f5" : "#fff9db",
            color:      value === "completed" ? "#198754" : value === "rejected" ? "#dc3545" : "#997404",
            border:     `1px solid ${value === "completed" ? "#b2f2bb" : value === "rejected" ? "#ffc9c9" : "#ffe066"}`,
            borderRadius: 20,
            fontSize: 13,
          }}
        >
          {value}
        </span>
      ),
    },
    {
      Header: "Refund By",
      accessor: "Refund By",
      Cell: ({ row }) => row.original.created_by || row.original.created_by || "—",
    },
    {
      Header: "Date",
      accessor: "created_at",
      Cell: ({ value }) => new Date(value).toLocaleString("en-IN"),
    },
  ];

  const formattedData = (data || []).map((row, idx) => ({
    ...row,
    sno: (page - 1) * limit + idx + 1,
  }));

  const handleSearch = (val, resetPage = null) => {
    setSearch(val);
    if (resetPage !== null) setPage(resetPage);
  };
  const onPageChange  = (p) => setPage(p);
  const onLimitChange = (n) => { setLimit(n); setPage(1); };

  return (
    <DataTable
      columns={columns}
      data={formattedData}
      options={{
        loading,
        error,
        sortableColumns: ["first_name", "amount", "status", "created_at"],
        copy: true,
        csv: true,
        pdf: true,
        print: true,
        fileName: "RefundHistory",
      }}
      Search={{ search: true, SearchInputValue: search, handleSearch }}
      Entries={{ Entries: true, limit, onLimitChange, options: sizeOptions }}
      pagination={{ isActive: true, meta, onPageChange }}
    />
  );
};

export default RefundHistoryTable;